<mat-drawer-container class="h-full flex-auto" autosize (backdropClick)="innerDrawer.close()">
  <mat-drawer #innerDrawer class="w-200" [disableClose]="true" [mode]="'over'" [opened]="false" [position]="'end'">
    @if (innerSliderMode() === 'itinerary') {
      <div class="flex h-full w-full flex-auto flex-col">
        <div class="sticky top-0">
          <div class="relative z-10 flex w-full flex-0 flex-col border-b">
            <div class="flex min-h-16 items-center justify-between border-b bg-gray-50 p-4 md:px-6">
              <div class="flex flex-col">
                <div class="truncate text-2xl font-black">{{ 'ship_interface.select_port_from_vessel_itinerary' | transloco }}</div>
                <div class="text-secondary">{{ 'ship_interface.search_and_select_the_port_from_vessel_s_itinerary' | transloco }}</div>
              </div>
              <button mat-icon-button [matTooltip]="'button.close' | transloco" (click)="innerDrawer.close()">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="relative flex flex-auto shrink flex-col overflow-y-auto bg-gray-100 p-8" sealScrollReset>
          <div class="bg-card flex w-full flex-0 flex-col overflow-hidden rounded-2xl shadow">
            <div class="flex flex-row items-center justify-between px-6 py-8">
              <div class="text-3xl font-black">{{ 'ship_interface.vessel_itinerary' | transloco }}</div>
              <mat-form-field class="seal-mat-dense seal-mat-rounded seal-mat-emphasized-affix w-full sm:w-auto sm:min-w-64" [subscriptSizing]="'dynamic'">
                <mat-icon class="mr-2 icon-size-5" [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                <input matInput [autocomplete]="'off'" [formControl]="searchPortInputControl" [placeholder]="'system.quick-search' | transloco" />
              </mat-form-field>
            </div>
            <div class="flex flex-auto overflow-hidden">
              <div class="flex flex-auto flex-col overflow-y-auto">
                <div
                  matSort
                  class="text-secondary sticky top-0 z-10 grid grid-cols-3 gap-4 bg-gray-50 px-6 py-4 text-md font-semibold shadow dark:bg-gray-800 md:px-8">
                  <div class="truncate">{{ 'ship_interface.port' | transloco }}</div>
                  <div class="truncate">{{ 'ship_interface.arrival' | transloco }}</div>
                  <div class="truncate">{{ 'ship_interface.departure' | transloco }}</div>
                </div>
                @if (displayedItinerary() && displayedItinerary().length) {
                  <cdk-virtual-scroll-viewport #virtualScroll class="w-full" style="height: calc(100vh - 390px)" [itemSize]="69" (scroll)="onScroll()">
                    <div *cdkVirtualFor="let itinerary of displayedItinerary()">
                      <a
                        class="grid cursor-pointer grid-cols-3 items-center gap-4 border-b px-6 py-4 dark:hover:bg-hover hover:bg-gray-100 md:px-8"
                        (click)="selectPort(itinerary)">
                        <div class="flex flex-col">
                          <div class="flex flex-row items-center justify-start">
                            <div class="truncate font-bold" [ngClass]="itinerary.flag_current === 1 ? 'text-primary' : ''">
                              {{ itinerary.port_name || '-' }}
                            </div>
                            @if (itinerary.flag_current === 1) {
                              <div class="ml-2 h-2 w-2 rounded-full bg-primary"></div>
                            }
                          </div>
                          <div class="truncate text-xs">{{ itinerary.port_country_name ? '(' + itinerary.port_country_name + ')' : '' }}</div>
                        </div>
                        <div class="flex flex-row items-center justify-start">
                          <div class="truncate" [ngClass]="itinerary.flag_arrival === 1 ? 'font-bold' : ''">
                            {{ itinerary.datetime_arrival ? (itinerary.datetime_arrival | local: { format: 'YYYY-MM-DD HH:mm' }) : '-' }}
                          </div>
                          @if (itinerary.flag_arrival === 1) {
                            <div
                              class="ml-2 inline-flex items-center rounded-md border border-red-500 px-1.5 py-0.5 text-xs uppercase tracking-wide text-red-500">
                              <div class="mr-1 h-1.5 w-1.5 rounded-full bg-red-500"></div>
                              <div class="mr-1 h-1.5 w-1.5 rounded-full bg-red-500"></div>
                              <div class="truncate whitespace-nowrap leading-relaxed">{{ 'ship_interface.arrived' | transloco }}</div>
                            </div>
                          }
                        </div>
                        <div class="flex flex-row items-center justify-start">
                          <div class="truncate" [ngClass]="itinerary.flag_departure === 1 ? 'font-bold' : ''">
                            {{ itinerary.datetime_departure ? (itinerary.datetime_departure | local: { format: 'YYYY-MM-DD HH:mm' }) : '-' }}
                          </div>
                          @if (itinerary.flag_departure === 1) {
                            <div
                              class="ml-2 inline-flex items-center rounded-md border border-primary px-1.5 py-0.5 text-xs uppercase tracking-wide text-primary">
                              <div class="mr-1 h-1.5 w-1.5 rounded-full bg-primary"></div>
                              <div class="mr-1 h-1.5 w-1.5 rounded-full bg-primary"></div>
                              <div class="truncate whitespace-nowrap leading-relaxed">{{ 'ship_interface.sailed' | transloco }}</div>
                            </div>
                          }
                        </div>
                      </a>
                    </div>
                    @if (isLoadingMore()) {
                      <div class="m-2 text-center">{{ 'ship_interface.loading' | transloco }}</div>
                    }
                  </cdk-virtual-scroll-viewport>
                } @else {
                  <div class="border-t p-8 text-center text-4xl font-semibold tracking-tight sm:p-16">
                    {{ 'ship_interface.no_vessel_itinerary' | transloco }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (innerSliderMode() === 'location') {}

    @if (innerSliderMode() === 'events') {
      <div class="flex h-full w-full flex-auto flex-col">
        <div class="sticky top-0">
          <div class="relative z-10 flex w-full flex-0 flex-col border-b">
            <div class="flex min-h-16 items-center border-b bg-gray-50 p-4 md:px-8">
              <div>
                <div class="mr-auto truncate text-2xl font-black">{{ 'ship_interface.select_timesheet_item' | transloco }}</div>
                <div class="text-secondary">
                  {{ 'ship_interface.you_can_search_and_select_the_timesheet_item_if_you_cannot_find_the_item_from_the_list_select_other_' | transloco }}
                </div>
              </div>
              <button mat-icon-button [matTooltip]="'button.close' | transloco" class="ml-4" (click)="innerDrawer.close()">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="relative flex flex-auto shrink flex-col overflow-y-auto bg-gray-100 p-8" sealScrollReset>
          <div class="bg-card flex w-full flex-0 flex-col overflow-hidden rounded-2xl shadow">
            <div class="flex flex-row items-center justify-between px-6 py-8">
              <div class="text-3xl font-black">{{ 'ship_interface.timesheet_events' | transloco }}</div>
              <mat-form-field class="seal-mat-dense seal-mat-rounded seal-mat-emphasized-affix w-full sm:w-auto sm:min-w-64" [subscriptSizing]="'dynamic'">
                <mat-icon class="mr-2 icon-size-5" [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                <input matInput [autocomplete]="'off'" [formControl]="searchEventItemInputControl" [placeholder]="'system.quick-search' | transloco" />
              </mat-form-field>
            </div>
            <div class="flex flex-auto overflow-hidden">
              <div class="flex flex-auto flex-col overflow-y-auto">
                <div
                  matSort
                  class="events-select-grid text-secondary sticky top-0 z-10 grid gap-4 bg-gray-50 px-6 py-4 text-md font-semibold shadow dark:bg-gray-800 md:px-8">
                  <div class="truncate">{{ 'ship_interface.timesheet_event_item' | transloco }}</div>
                  <div class="truncate pr-10 text-center">{{ 'ship_interface.from_to' | transloco }}</div>
                </div>
                @if (displayedEventItems() && displayedEventItems().length) {
                  <cdk-virtual-scroll-viewport
                    #virtualScrollEvents
                    class="w-full"
                    style="height: calc(100vh - 410px)"
                    [itemSize]="57"
                    (scroll)="onScrollEvents()">
                    <div *cdkVirtualFor="let event of displayedEventItems()">
                      <a
                        class="events-select-grid grid cursor-pointer items-center gap-4 border-b px-6 py-4 dark:hover:bg-hover hover:bg-gray-100 md:px-8"
                        [ngClass]="{ 'bg-primary-100 dark:bg-primary-900': event.id === selectedEvent()?.timesheet_event_item_id }"
                        (click)="selectEvent(event)">
                        <div class="flex flex-row items-center justify-start">
                          <div class="truncate font-bold">{{ event.name || '-' }}</div>
                        </div>
                        <div class="flex w-full flex-row justify-center">
                          <mat-icon [ngClass]="event.flag_from_to === 1 ? 'text-blue-600' : 'text-gray-300'">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M12 0C5.38322 0 0 5.38322 0 12C0 18.6168 5.38322 24 12 24C18.6168 24 24 18.6168 24 12C23.9996 5.38322 18.6168 0 12 0ZM12 22.0659C6.44961 22.0659 1.93415 17.5504 1.93415 11.9996C1.93415 6.44918 6.44961 1.93372 12 1.93372C17.5504 1.93372 22.0659 6.44961 22.0659 12C22.0659 17.5504 17.5504 22.0659 12 22.0659Z"
                                fill="currentColor" />
                              <path
                                d="M15.8256 8.17297L10.2243 13.7746L8.1747 11.725C7.79727 11.3471 7.18501 11.3471 6.80757 11.725C6.4297 12.1025 6.4297 12.7147 6.80757 13.0921L9.54097 15.8255C9.72969 16.0143 9.97744 16.1091 10.2248 16.1091C10.4721 16.1091 10.7194 16.0147 10.9081 15.8255L17.1931 9.54053C17.5706 9.16267 17.5706 8.55084 17.1931 8.17297C16.8153 7.79553 16.2034 7.79553 15.8256 8.17297Z"
                                fill="currentColor" />
                            </svg>
                          </mat-icon>
                        </div>
                      </a>
                    </div>
                    @if (isLoadingMore()) {
                      <div class="m-2 text-center">{{ 'ship_interface.loading' | transloco }}</div>
                    }
                  </cdk-virtual-scroll-viewport>
                } @else {
                  <div class="border-t p-8 text-center text-4xl font-semibold tracking-tight sm:p-16">
                    {{ 'ship_interface.no_itinerary_items' | transloco }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </mat-drawer>

  <mat-drawer-content class="flex w-full flex-auto flex-col p-6 md:p-8">
    <div class="flex items-center justify-between">
      @if (!editMode()) {
        <div class="flex flex-col justify-center">
          <span class="text-2xl font-black">{{ 'ship_interface.view_timesheet' | transloco }}</span>
        </div>

        <div class="flex items-center">
          <a mat-icon-button [routerLink]="['../']">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </a>
        </div>
      }

      @if (editMode()) {
        @if (timesheet().id) {
          <div class="flex flex-col">
            <div class="text-2xl font-black">{{ 'ship_interface.edit_timesheet' | transloco }}</div>

            <div class="text-md font-normal">{{ 'ship_interface.update_the_timesheet_here' | transloco }}</div>
          </div>

          <div class="flex items-center">
            <button mat-icon-button (click)="toggleEditMode(false)">
              <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
          </div>
        } @else {
          <div class="flex flex-col">
            <div class="text-2xl font-black">{{ 'ship_interface.create_new_timesheet' | transloco }}</div>

            <div class="text-md font-normal">{{ 'ship_interface.you_can_create_new_timesheet_from_here' | transloco }}</div>
          </div>

          <div class="flex items-center">
            <a mat-icon-button [routerLink]="['../']">
              <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </a>
          </div>
        }
      }
    </div>

    @if (!editMode()) {
      <div class="bg-card mt-4 flex h-full flex-col overflow-hidden rounded-2xl shadow">
        <div class="flex items-center border-b bg-gray-50 px-6 py-3 dark:bg-gray-700">
          <div class="text-lg font-bold leading-none tracking-tight">{{ 'ship_interface.timesheet_information' | transloco }}</div>

          <div class="ml-auto hidden sm:flex sm:items-center">
            <button *permission="['time_sheet_sof', ['create']]" mat-icon-button [matTooltip]="'button.edit' | transloco" (click)="toggleEditMode(true)">
              <mat-icon class="icon-size-5" [svgIcon]="'feather:edit'"></mat-icon>
            </button>

            <button *permission="['time_sheet_sof', ['delete']]" mat-icon-button [matTooltip]="'button.delete' | transloco" (click)="deleteTimesheet()">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
            </button>
          </div>

          <div *permission="['time_sheet_sof', ['create', 'delete'], 'or']" class="ml-auto flex items-center sm:hidden">
            <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation(); $event.preventDefault()">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
            </button>

            <mat-menu #actionMenu="matMenu">
              <button *permission="['time_sheet_sof', ['create']]" mat-menu-item (click)="toggleEditMode(true)">
                <mat-icon class="icon-size-5" [svgIcon]="'feather:edit'"></mat-icon>

                {{ 'button.edit' | transloco }}
              </button>

              <button *permission="['time_sheet_sof', ['delete']]" mat-menu-item (click)="deleteTimesheet()">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>

                {{ 'button.delete' | transloco }}
              </button>
            </mat-menu>
          </div>
        </div>

        <div class="flex flex-auto flex-col space-y-10 overflow-y-auto border-t p-12">
          <div class="flex items-center">
            <div>
              <div class="ml-1 truncate text-3xl font-bold">
                {{ profile()?.name }} | {{ profile()?.call_sign || '-' }} &#64;{{ timesheet()?.port_name }} ({{
                  timesheet()?.date_timesheet | local: { format: 'DD MMM YYYY' }
                }})
              </div>

              <div class="mt-0.5 flex flex-wrap items-center space-x-3">
                <div
                  class="flex items-center justify-center rounded-full px-3 py-1 leading-normal"
                  [ngClass]="(timesheet()?.status_id | sealFindByKey: 'id' : timesheetStatuses)?.color">
                  <span class="whitespace-nowrap text-sm font-medium">{{ timesheet()?.status_name || '-' }}</span>
                </div>

                <div
                  class="flex items-center justify-center rounded-full px-3 py-1 leading-normal"
                  [ngClass]="(timesheet()?.type_id | sealFindByKey: 'id' : timesheetTypes)?.color">
                  <span class="whitespace-nowrap text-sm font-medium">{{ timesheet()?.type_name || '-' }}</span>
                </div>
              </div>
            </div>
          </div>

          <mat-divider class="-mx-12"></mat-divider>

          <p class="flex items-center text-2xl font-bold">{{ 'ship_interface.basic_details' | transloco }}</p>

          <div class="grid grid-cols-2 gap-x-6 gap-y-8">
            <div class="flex flex-col">
              <div class="text-secondary text-sm font-medium leading-none">{{ 'ship_interface.port_location' | transloco }}</div>

              <div class="mt-2 min-h-4 text-lg font-medium leading-none">
                {{ timesheet()?.port_name || '-' }}
                @if (timesheet()?.country_name) {
                  <span>, {{ timesheet()?.country_name }}</span>
                }
                /
                {{ timesheet()?.location_name || '-' }}
              </div>
            </div>

            <div class="flex flex-col">
              <div class="text-secondary text-sm font-medium leading-none">{{ 'ship_interface.cargo' | transloco }}</div>

              <div class="mt-2 min-h-4 text-lg font-medium leading-none">
                {{ timesheet()?.cargo_name || '-' }}
              </div>
            </div>

            <div class="flex flex-col">
              <div class="text-secondary text-sm font-medium leading-none">{{ 'ship_interface.b_l_quantity' | transloco }}</div>

              <div class="mt-2 min-h-4 text-lg font-medium leading-none">
                {{ timesheet()?.quantity_document ? (timesheet()?.quantity_document | number: '1.3-3') + ' MT' : '-' }}
              </div>
            </div>

            <div class="flex flex-col">
              <div class="text-secondary text-sm font-medium leading-none">{{ 'ship_interface.ship_figure' | transloco }}</div>

              <div class="mt-2 min-h-4 text-lg font-medium leading-none">
                {{ timesheet()?.quantity_ship ? (timesheet()?.quantity_ship | number: '1.3-3') + ' MT' : '-' }}
              </div>
            </div>
          </div>

          <mat-divider class="-mx-12"></mat-divider>

          <p class="flex items-center text-2xl font-bold">{{ 'ship_interface.timesheet_events' | transloco }}</p>

          <div>
            <div class="bg-default -mx-6 grid grid-cols-3 rounded-t-2xl border-b px-10 py-3 dark:bg-gray-700">
              <div class="flex items-center truncate font-semibold">{{ 'ship_interface.event' | transloco }}</div>
              <div class="flex items-center truncate font-semibold">{{ 'ship_interface.time_stamp' | transloco }}</div>
              <div class="flex items-center truncate font-semibold">{{ 'ship_interface.remarks' | transloco }}</div>
            </div>

            @if (timesheet()?.events?.length > 0) {
              @for (event of timesheet()?.events; track trackByFn(i, event); let i = $index) {
                <div class="-mx-6 grid grid-cols-3 border-b px-10 py-3">
                  <div class="flex items-center truncate">{{ event?.timesheet_event_item_name || '-' }}</div>
                  <div class="flex items-center truncate">
                    {{ event?.datetime_event ? (event?.datetime_event | local: { format: 'YYYY-MM-DD HH:mm' }) : '-' }}
                  </div>
                  <div class="flex items-center truncate">{{ event?.remarks || '-' }}</div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }

    @if (editMode()) {
      <mat-drawer-container class="bg-card mt-4 h-full flex-auto rounded-2xl shadow">
        <mat-drawer #editDrawer class="w-full dark:bg-gray-900 sm:w-60 sm:min-w-60" [autoFocus]="false" [mode]="drawerMode()" [opened]="false">
          <div class="flex h-16 items-center justify-between bg-gray-50 px-6 py-3 dark:bg-gray-700">
            <div class="text-secondary text-lg font-bold leading-none tracking-tight">{{ 'ship_interface.field_filters' | transloco }}</div>

            <div class="lg:hidden">
              <button mat-icon-button (click)="editDrawer.close()">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
              </button>
            </div>
          </div>

          <div class="flex h-full flex-col overflow-y-auto border-t">
            <div class="flex flex-col divide-y">
              @if (!timesheet()?.id) {
                <div
                  class="flex cursor-pointer flex-col px-4 py-5"
                  [ngClass]="{ 'dark:hover:bg-hover hover:bg-gray-100': formMode() !== 'mandatory', 'bg-primary-50 dark:bg-hover': formMode() === 'mandatory' }"
                  (click)="selectFormMode('mandatory')">
                  <div class="font-bold leading-6" [ngClass]="{ 'text-primary dark:text-primary-500': formMode() === 'mandatory' }">
                    {{ 'ship_interface.mandatory_fields_only' | transloco }}
                  </div>

                  <div class="text-secondary mt-0.5 text-sm">
                    {{ 'ship_interface.fill_out_all_only_the_mandatory_fields_to_quickly_create_new_record' | transloco }}
                  </div>
                </div>

                <div
                  class="flex cursor-pointer flex-col px-4 py-5"
                  [ngClass]="{ 'dark:hover:bg-hover hover:bg-gray-100': formMode() !== 'all', 'bg-primary-50 dark:bg-hover': formMode() === 'all' }"
                  (click)="selectFormMode('all')">
                  <div class="font-bold leading-6" [ngClass]="{ 'text-primary dark:text-primary-500': formMode() === 'all' }">
                    {{ 'ship_interface.complete_form' | transloco }}
                  </div>

                  <div class="text-secondary mt-0.5 text-sm">{{ 'ship_interface.fill_in_all_available_fields' | transloco }}</div>
                </div>
              }

              @if (timesheet()?.id) {
                <div
                  class="flex cursor-pointer flex-col px-4 py-5"
                  [ngClass]="{ 'dark:hover:bg-hover hover:bg-gray-100': formMode() !== 'basic', 'bg-primary-50 dark:bg-hover': formMode() === 'basic' }"
                  (click)="selectFormMode('basic')">
                  <div class="font-bold leading-6" [ngClass]="{ 'text-primary dark:text-primary-500': formMode() === 'basic' }">
                    {{ 'ship_interface.basic_details' | transloco }}
                  </div>

                  <div class="text-secondary mt-0.5 text-sm">{{ 'ship_interface.basic_details_of_the_timesheet' | transloco }}</div>
                </div>

                <div
                  class="flex cursor-pointer flex-col px-4 py-5"
                  [ngClass]="{ 'dark:hover:bg-hover hover:bg-gray-100': formMode() !== 'events', 'bg-primary-50 dark:bg-hover': formMode() === 'events' }"
                  (click)="selectFormMode('events')">
                  <div class="font-bold leading-6" [ngClass]="{ 'text-primary dark:text-primary-500': formMode() === 'events' }">
                    {{ 'ship_interface.timesheet_items' | transloco }}
                  </div>

                  <div class="text-secondary mt-0.5 text-sm">{{ 'ship_interface.edit_timesheet_events' | transloco }}</div>
                </div>
              }

              <div class="flex h-26 flex-col px-4 py-5"></div>
            </div>
          </div>
        </mat-drawer>

        <mat-drawer-content class="flex h-full flex-col">
          <div class="flex items-center border-b bg-gray-50 px-6 py-3 dark:bg-gray-700">
            <button class="-ml-2" mat-icon-button (click)="editDrawer.toggle()">
              <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>

            <div class="ml-2 text-lg font-bold leading-none tracking-tight">{{ 'ship_interface.timesheet_information' | transloco }}</div>
          </div>

          <form [formGroup]="timesheetForm" class="mb-18 overflow-y-auto border-t" (keydown.enter)="$event.preventDefault()">
            <div class="grid gap-x-4 gap-y-2 p-12 md:grid-cols-2">
              @if (formMode() === 'all' || formMode() === 'mandatory' || formMode() === 'basic') {
                <p class="mb-10 flex items-center text-2xl font-bold md:col-span-2">{{ 'ship_interface.basic_details' | transloco }}</p>

                @if (formMode() === 'all' || formMode() === 'basic') {
                  <div class="col-span-2">
                    <mat-form-field class="w-full">
                      <mat-label>{{ 'ship_interface.master_name' | transloco }}</mat-label>

                      <input matInput [formControlName]="'master_name'" [placeholder]="'ship_interface.master_name' | transloco" />

                      <mat-error>{{ 'ship_interface.master_name_is_required' | transloco }}</mat-error>
                    </mat-form-field>
                  </div>
                }

                <div>
                  <mat-form-field class="w-full">
                    <mat-label>{{ 'ship_interface.voyage_number' | transloco }}</mat-label>

                    <input matInput [formControlName]="'voyage_number'" [placeholder]="'ship_interface.voyage_number' | transloco" />

                    <mat-error>{{ 'ship_interface.voyage_number_is_required' | transloco }}</mat-error>
                  </mat-form-field>
                </div>

                <div [formGroupName]="'date_timesheet'">
                  <mat-form-field class="w-full">
                    <mat-label>{{ 'ship_interface.timesheet_date' | transloco }}</mat-label>

                    <input matInput class="text-default font-medium" [formControlName]="'date'" [matDatepicker]="datePicker" [placeholder]="'DDMMMYYYY'" />

                    <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>

                    <mat-datepicker #datePicker [disabled]="false">
                      <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel (click)="timesheetForm.get('date_timesheet').reset()">
                          {{ 'button.clear' | transloco }}
                        </button>

                        <button mat-flat-button matDatepickerApply [color]="'primary'">
                          {{ 'button.select' | transloco }}
                        </button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-span-2">
                  <mat-label class="font-medium">{{ 'ship_interface.timesheet_type' | transloco }} *</mat-label>

                  <mat-button-toggle-group
                    class="mt-1 flex items-center justify-center space-x-2"
                    [formControlName]="'type_id'"
                    name="timesheetType"
                    aria-label="Timesheet Type">
                    @for (type of timesheetTypes; track type) {
                      <mat-button-toggle class="w-full border-2" [value]="type.id">{{ type.description }} </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                </div>

                <div class="mt-5">
                  <div class="mb-2 truncate font-medium leading-4">{{ 'ship_interface.select_delivery_port_from_vessel_itinerary' | transloco }} *</div>

                  <div
                    class="flex h-[50px] w-full cursor-pointer flex-row items-center justify-start rounded-[8px] border-[1.5px] px-4"
                    (click)="openItineraryDrawer()">
                    @if (timesheetForm.get('port_name')?.value) {
                      <div class="text-normal truncate font-medium">
                        {{ timesheetForm.get('port_name')?.value }}
                        {{ timesheetForm.get('country_name')?.value ? ' (' + timesheetForm.get('country_name')?.value + ')' : '' }}
                      </div>
                    } @else {
                      <div class="italic text-blue-600">{{ 'ship_interface.click_here_to_select_port' | transloco }}</div>
                    }
                  </div>
                </div>

                <div class="mt-5">
                  <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>{{ 'ship_interface.location' | transloco }}</mat-label>

                    <input
                      matInput
                      [formControlName]="'location_id'"
                      [matAutocomplete]="locationAutocomplete"
                      [placeholder]="'ship_interface.location_name' | transloco"
                      [spellcheck]="false" />

                    <mat-autocomplete
                      #locationAutocomplete="matAutocomplete"
                      class="max-h-128 rounded-b border-t shadow-md sm:px-2"
                      [autoSelectActiveOption]="true"
                      [disableRipple]="true"
                      [displayWith]="displayLocations.bind(this, timesheetForm)"
                      (optionSelected)="selectLocationAutofill($event)">
                      @if (searchedLocations() && !searchedLocations().length) {
                        <mat-option class="text-secondary pointer-events-none px-6 py-0 text-md">{{
                          'ship_interface.no_locations_found' | transloco
                        }}</mat-option>
                      }

                      @for (location of searchedLocations(); track trackByFn($index, location)) {
                        <mat-option class="text-normal font-medium" [value]="location.id">
                          <span class="truncate">{{ location.name }}</span>
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>

                <div class="col-span-2 mt-5">
                  <mat-form-field class="w-full">
                    <mat-label>{{ 'ship_interface.cargo_grade' | transloco }}</mat-label>

                    <input matInput [formControlName]="'cargo_name'" [placeholder]="'ship_interface.cargo_grade' | transloco" />

                    <mat-error>{{ 'ship_interface.cargo_grade_is_required' | transloco }}</mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field class="w-full">
                    <mat-label>{{ 'ship_interface.document_quantity' | transloco }}</mat-label>

                    <div matTextSuffix class="ml-2">{{ 'ship_interface.mt' | transloco }}</div>

                    <input
                      matInput
                      [formControlName]="'quantity_document'"
                      decimalMarker="."
                      mask="separator.3"
                      thousandSeparator=","
                      [placeholder]="'ship_interface.document_quantity' | transloco" />

                    <mat-error>{{ 'ship_interface.document_quantity_is_required' | transloco }}</mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field class="w-full">
                    <mat-label>{{ 'ship_interface.ship_quantity' | transloco }}</mat-label>

                    <div matTextSuffix class="ml-2">{{ 'ship_interface.mt' | transloco }}</div>

                    <input
                      matInput
                      [formControlName]="'quantity_ship'"
                      decimalMarker="."
                      mask="separator.3"
                      thousandSeparator=","
                      [placeholder]="'ship_interface.ship_quantity' | transloco" />

                    <mat-error>{{ 'ship_interface.ship_quantity_is_required' | transloco }}</mat-error>
                  </mat-form-field>
                </div>

                @if (formMode() === 'all' || formMode() === 'basic') {
                  <div class="col-span-2">
                    <mat-form-field class="mt-2 w-full">
                      <mat-label>{{ 'ship_interface.remarks' | transloco }}</mat-label>

                      <input matInput [formControlName]="'remarks'" [placeholder]="'ship_interface.remarks' | transloco" />
                    </mat-form-field>
                  </div>
                }
              }

              @if (formMode() === 'events') {
                <div class="mb-6 md:col-span-2">
                  <div class="mb-6 flex items-center justify-between">
                    <p class="flex items-center text-2xl font-bold">{{ 'ship_interface.timesheet_events' | transloco }}</p>

                    <button mat-button [color]="'primary'" (click)="addEventField()">
                      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon>

                      <span class="ml-2">{{ 'ship_interface.add_new_item' | transloco }}</span>
                    </button>
                  </div>

                  <div class="timesheet-events-grid bg-default -mx-6 grid gap-4 rounded-t-2xl border-b px-10 py-3 dark:bg-gray-700">
                    <div></div>
                    <div class="col-span-2 flex items-center truncate font-semibold">{{ 'ship_interface.event' | transloco }}</div>
                    <div class="flex items-center truncate font-semibold">{{ 'ship_interface.time_stamp' | transloco }}</div>
                    <div class="flex items-center truncate font-semibold">{{ 'ship_interface.remarks' | transloco }}</div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                  <div cdkDropList (cdkDropListDropped)="drop($event)">
                    @for (
                      event of timesheetForm.get('timesheet_events')['controls'];
                      track trackByFn(i, event);
                      let i = $index;
                      let first = $first;
                      let last = $last
                    ) {
                      <div cdkDrag class="timesheet-events-grid -mx-6 grid gap-4 border-b p-10 py-2">
                        <div cdkDragHandle class="flex cursor-pointer items-center justify-center">
                          <mat-icon [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
                        </div>

                        <div class="flex items-center justify-center">
                          <button
                            mat-icon-button
                            [color]="'primary'"
                            (click)="openEventsDrawer(event, i)"
                            [matTooltip]="'button.select-timesheet-item' | transloco">
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                          </button>
                        </div>

                        <!--TODO: Change from id to name-->
                        <div class="flex items-center">
                          <mat-form-field class="seal-mat-dense seal-mat-no-borders w-full font-bold" [subscriptSizing]="'dynamic'">
                            <input
                              matInput
                              [formControl]="event.get('timesheet_event_item_id')"
                              [matAutocomplete]="eventItemAutocomplete"
                              [placeholder]="'ship_interface.event_item_name' | transloco"
                              [spellcheck]="false" />

                            <mat-autocomplete
                              #eventItemAutocomplete="matAutocomplete"
                              class="max-h-128 rounded-b border-t shadow-md sm:px-2"
                              [autoSelectActiveOption]="true"
                              [disableRipple]="true"
                              [displayWith]="displayItems.bind(this, event)"
                              (optionSelected)="selectEventItemAutofill($event, event)">
                              @if (searchedEventItems() && !searchedEventItems().length) {
                                <mat-option class="text-secondary pointer-events-none px-6 py-0 text-md">{{
                                  'ship_interface.no_event_items_found' | transloco
                                }}</mat-option>
                              }

                              @for (item of searchedEventItems(); track trackByFn($index, item)) {
                                <mat-option class="text-normal font-medium" [value]="item.id">
                                  <span class="truncate">{{ item.name }}</span>
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>

                        <!--TIME STAMP-->
                        <div class="flex flex-col justify-center">
                          @if (event.get('flag_from_to').value) {
                            <!--DATETIME FROM / DATETIME TO-->
                            <div class="flex flex-row items-center">
                              <mat-form-field class="seal-mat-dense seal-mat-no-borders mr-2 w-1/2" [subscriptSizing]="'dynamic'">
                                <input
                                  matInput
                                  class="text-default"
                                  [placeholder]="'DDMMMYYYY'"
                                  [formControl]="event.get('datetime_from').get('date')"
                                  [matDatepicker]="datePicker2" />

                                <mat-datepicker-toggle matIconSuffix [for]="datePicker2"></mat-datepicker-toggle>

                                <mat-datepicker #datePicker2 [disabled]="false">
                                  <mat-datepicker-actions>
                                    <button
                                      mat-button
                                      matDatepickerCancel
                                      (click)="event.get('datetime_from').get('date').reset(); event.get('datetime_from').get('time').reset()">
                                      {{ 'button.clear' | transloco }}
                                    </button>

                                    <button mat-flat-button matDatepickerApply [color]="'primary'">
                                      {{ 'button.select' | transloco }}
                                    </button>
                                  </mat-datepicker-actions>
                                </mat-datepicker>
                              </mat-form-field>

                              <mat-form-field class="seal-mat-dense seal-mat-no-borders w-1/2 min-w-24" [subscriptSizing]="'dynamic'">
                                <input
                                  matInput
                                  class="text-center"
                                  mask="Hh:m0"
                                  [placeholder]="'ship_interface.hhmm' | transloco"
                                  [formControl]="event.get('datetime_from').get('time')"
                                  [leadZeroDateTime]="true" />
                              </mat-form-field>
                            </div>

                            <div class="mt-2 flex flex-row items-center">
                              <mat-form-field class="seal-mat-dense seal-mat-no-borders mr-2 w-1/2" [subscriptSizing]="'dynamic'">
                                <input
                                  matInput
                                  class="text-default"
                                  [placeholder]="'DDMMMYYYY'"
                                  [formControl]="event.get('datetime_to').get('date')"
                                  [matDatepicker]="datePicker3" />

                                <mat-datepicker-toggle matIconSuffix [for]="datePicker3"></mat-datepicker-toggle>

                                <mat-datepicker #datePicker3 [disabled]="false">
                                  <mat-datepicker-actions>
                                    <button
                                      mat-button
                                      matDatepickerCancel
                                      (click)="event.get('datetime_to').get('date').reset(); event.get('datetime_to').get('time').reset()">
                                      {{ 'button.clear' | transloco }}
                                    </button>

                                    <button mat-flat-button matDatepickerApply [color]="'primary'">
                                      {{ 'button.select' | transloco }}
                                    </button>
                                  </mat-datepicker-actions>
                                </mat-datepicker>
                              </mat-form-field>

                              <mat-form-field class="seal-mat-dense seal-mat-no-borders w-1/2 min-w-24" [subscriptSizing]="'dynamic'">
                                <input
                                  matInput
                                  class="text-center"
                                  mask="Hh:m0"
                                  [placeholder]="'ship_interface.hhmm' | transloco"
                                  [formControl]="event.get('datetime_to').get('time')"
                                  [leadZeroDateTime]="true" />
                              </mat-form-field>
                            </div>
                          } @else {
                            <div class="flex flex-row items-center">
                              <mat-form-field class="seal-mat-dense seal-mat-no-borders mr-2 w-1/2" [subscriptSizing]="'dynamic'">
                                <input
                                  matInput
                                  class="text-default"
                                  [placeholder]="'DDMMMYYYY'"
                                  [formControl]="event.get('datetime_event').get('date')"
                                  [matDatepicker]="datePicker4" />

                                <mat-datepicker-toggle matIconSuffix [for]="datePicker4"></mat-datepicker-toggle>

                                <mat-datepicker #datePicker4 [disabled]="false">
                                  <mat-datepicker-actions>
                                    <button
                                      mat-button
                                      matDatepickerCancel
                                      (click)="event.get('datetime_event').get('date').reset(); event.get('datetime_event').get('time').reset()">
                                      {{ 'button.clear' | transloco }}
                                    </button>

                                    <button mat-flat-button matDatepickerApply [color]="'primary'">
                                      {{ 'button.select' | transloco }}
                                    </button>
                                  </mat-datepicker-actions>
                                </mat-datepicker>
                              </mat-form-field>

                              <mat-form-field class="seal-mat-dense seal-mat-no-borders w-1/2 min-w-24" [subscriptSizing]="'dynamic'">
                                <input
                                  matInput
                                  class="text-center"
                                  mask="Hh:m0"
                                  [placeholder]="'ship_interface.hhmm' | transloco"
                                  [formControl]="event.get('datetime_event').get('time')"
                                  [leadZeroDateTime]="true" />
                              </mat-form-field>
                            </div>
                          }
                        </div>

                        <div class="flex items-center">
                          <mat-form-field class="seal-mat-dense seal-mat-no-borders w-full" [subscriptSizing]="'dynamic'">
                            <input
                              matInput
                              [formControl]="event.get('remarks')"
                              [placeholder]="'ship_interface.enter_remarks_if_any' | transloco"
                              [spellcheck]="false" />
                          </mat-form-field>
                        </div>

                        <div class="flex items-center justify-center">
                          <button
                            mat-icon-button
                            class="h-8 min-h-8 w-8"
                            [matTooltip]="'button.toggle-from-to' | transloco"
                            (click)="toggleControl(event.get('flag_from_to')); resetDates(event)">
                            <mat-icon class="icon-size-5" [ngClass]="event.get('flag_from_to').value === 1 ? 'text-blue-600' : 'text-gray-300'">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.625 2.5H9.375V17.5H10.625V2.5Z" fill="currentColor" />
                                <path
                                  d="M6.25 4.375V15.625H2.5V4.375H6.25ZM6.25 3.125H2.5C2.16848 3.125 1.85054 3.2567 1.61612 3.49112C1.3817 3.72554 1.25 4.04348 1.25 4.375V15.625C1.25 15.9565 1.3817 16.2745 1.61612 16.5089C1.85054 16.7433 2.16848 16.875 2.5 16.875H6.25C6.58152 16.875 6.89946 16.7433 7.13388 16.5089C7.3683 16.2745 7.5 15.9565 7.5 15.625V4.375C7.5 4.04348 7.3683 3.72554 7.13388 3.49112C6.89946 3.2567 6.58152 3.125 6.25 3.125Z"
                                  fill="currentColor" />
                                <path
                                  d="M17.5 4.375V15.625H13.75V4.375H17.5ZM17.5 3.125H13.75C13.4185 3.125 13.1005 3.2567 12.8661 3.49112C12.6317 3.72554 12.5 4.04348 12.5 4.375V15.625C12.5 15.9565 12.6317 16.2745 12.8661 16.5089C13.1005 16.7433 13.4185 16.875 13.75 16.875H17.5C17.8315 16.875 18.1495 16.7433 18.3839 16.5089C18.6183 16.2745 18.75 15.9565 18.75 15.625V4.375C18.75 4.04348 18.6183 3.72554 18.3839 3.49112C18.1495 3.2567 17.8315 3.125 17.5 3.125Z"
                                  fill="currentColor" />
                              </svg>
                            </mat-icon>
                          </button>
                        </div>

                        <div class="flex items-center justify-center">
                          <button
                            mat-icon-button
                            class="h-8 min-h-8 w-8"
                            [matTooltip]="'button.toggle-lock' | transloco"
                            (click)="toggleControl(event.get('flag_lock'))">
                            @if (!event.get('flag_lock').value) {
                              <mat-icon class="text-gray-300 icon-size-5" [svgIcon]="'heroicons_outline:lock-open'"></mat-icon>
                            }
                            @if (event.get('flag_lock').value === 1) {
                              <mat-icon class="text-blue-600 icon-size-5" [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
                            }
                          </button>
                        </div>

                        <div class="flex items-center justify-center">
                          <button
                            mat-icon-button
                            class="h-8 min-h-8 w-8"
                            [color]="'warn'"
                            [matTooltip]="'button.remove' | transloco"
                            (click)="removeEventField(i)">
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </form>

          <div class="bg-card absolute inset-x-0 bottom-0 z-30 flex items-center border-t px-6 py-4">
            @if (timesheet()?.id) {
              <button mat-button class="ml-auto" [color]="'warn'" (click)="toggleEditMode(false)">{{ 'ship_interface.discard' | transloco }}</button>
            }

            <button
              mat-flat-button
              [ngClass]="{ 'ml-3 px-6': timesheet()?.id, 'ml-auto': !timesheet()?.id }"
              [disabled]="timesheetForm.invalid"
              [color]="'primary'"
              (click)="saveTimesheet()">
              {{ 'ship_interface.save' | transloco }}
            </button>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    }
  </mat-drawer-content>
</mat-drawer-container>
